module.exports = __webpack_public_path__ + "img/question-visual-mobile.d367fe87.png";